module.exports = __webpack_public_path__ + "static/media/tarapaca.fbb0ed07.jpg";